import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers} from '../../views/textNumber-input/text-number';
import {specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import MenuContext from '../../../context/menuContext';
import {useMenu} from '../../../hooks/useMenu';
import Proving from './proving';
import ProvingPB from './provingPB';

function ProvingTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {selected, onComponent} = useMenu();

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={53}
      defaultKey4={13}
      defaultKey5={53}
      defaultKey6={65}
      defaultKey7={53}
      defaultKey8={13}
      defaultKey9={53}
      defaultKey10={65}
      defaultKey11={53}
      defaultKey12={9}
      onSave={() => onComponent(<ProvingPB />)}
      onLeftHold={() => onComponent(<Proving initiallyDisableKeypress continueProving />)}
      title="Enter Config File Name"
      caption="'M','M','I',0,0,0,0,0,0,0,0,0,0,0,0,0,0,0"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default ProvingTN;
